import { v4 as uuidv4, validate as uuidv4Validate } from 'uuid';

export const generateId = () => uuidv4();
export const validateId = (value: string) => uuidv4Validate(value);
